import ButtonLoadingContent from '../../../../shared/Loading/ButtonLoadingContent';

const Toolbar = (props) => {
  return (
    <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4'>
        <h2 className="text-2xl font-bold text-gray-800 sm:text-3xl md:text-4xl">
            ¿Cómo acumular puntos?
        </h2>
        {props.isEditor && 
            <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <button
                    onClick={() => props.handleAddLevel()}
                    className={`w-full sm:w-auto px-4 py-2 text-sm border border-transparent text-white rounded ${
                        props.loading
                            ? 'bg-purple-200 cursor-not-allowed'
                            : 'bg-personalized hover:bg-gray-100 hover:text-personalized hover:border-personalized'
                        }`}
                    >
                        <ButtonLoadingContent loading={props.loading}>
                            + Agregar nivel
                        </ButtonLoadingContent>
                </button>
                <button className={`w-full sm:w-auto px-4 py-2 text-sm border border-transparent text-white rounded
                    ${
                        props.loading || props.levels.some(l => !l.Insignia?.trim()
                    || l.EquivalentActivities?.some(act => !act.text?.trim()))
                            ? 'bg-purple-200 cursor-not-allowed'
                            : 'bg-personalized hover:bg-gray-100 hover:text-personalized hover:border-personalized'
                        }
                    `}
                    onClick={() => props.saveChangeLevels()}
                >
                    <ButtonLoadingContent loading={props.loading}>
                        Guardar cambios de niveles
                    </ButtonLoadingContent>
                </button>
            </div>
        }
    </div>
  );
};

export default Toolbar;
